import { useBranding } from "@/branding/BrandingContext";

/** Bloque tipográfico Figma 1126:5515 — debajo del grid destacado. */
export default function PulseEditorialTagline() {
  const { slug, brand } = useBranding();
  const isIaNewsletter = slug === "radaria" || /\bia\b/i.test(brand ?? "");

  return (
    <div
      className={`pulse-editorial-tagline ${
        isIaNewsletter ? "pulse-editorial-tagline--ia" : "pulse-editorial-tagline--mkt"
      }`}
    >
      <p className="m-0 whitespace-pre">
        <span className="pulse-editorial-tagline__regular">Tu</span>
        <span className="pulse-editorial-tagline__emphasis"> Actualidad</span>
      </p>
      <p className="m-0 whitespace-pre">
        <span className="pulse-editorial-tagline__emphasis whitespace-nowrap">
          {isIaNewsletter ? "de IA " : "Publicitaria "}
        </span>
        <span className="pulse-editorial-tagline__regular">powered </span>
      </p>
      <p className="m-0 whitespace-pre">
        <span className="pulse-editorial-tagline__regular">by</span>
        <span className="pulse-editorial-tagline__emphasis"> Iberdrola®</span>
      </p>
    </div>
  );
}
